<template>
  <div>
    <div><p class="custom-gradient text-center mb-6 mt-4 text-xl" v-if="createMatchMode"> {{ $t("select_hour_for_your_match") }}</p></div>
    <div class="search-reference flex flex-col">
      <div class="flex flex-col justify-center p-4">

        <div class="flex items-center gap-4 max-w-[720px] md:self-center">
          <div class="flex-1 min-w-0">
            <DaysSelector
              :selected="$route.query.date"
              :showTitle="false"
              @getAvailability="handleGetAvailability"
            />
          </div>
          <div class="flex-shrink-0">
            <button
              @click="showTimeSelector = true"
              class="reference-seach px-4 py-2"
            >
              {{ time }}
            </button>
          </div>
        </div>
        <div class="flex flex-wrap justify-between mt-6 search-container mx-auto gap-2">
          <div v-if="!createInClub" class="input-component relative flex-1 min-w-[200px]">
            <InputWhere
              :key="inputWhereKey"
              :placeholder="$t('search_your_clubs_cities')"
              :addLocations="true"
              :onlyOneSelect="true"
              :searchTenantEnabled="true"
              :externalSearchQuery="whereSearchQuery"
              @tenantsLocationsSelected="handleLocations"
              @sendNearSearch="handleLocations"
              @sendFavoritesSearch="handleLocations"
              @sendTenantToBooking="handleTenantToBooking"
            />
          </div>
          <div v-if="!createMatchMode">
            <CategorySelector  
              :optionDefault="selectedCategory"
              @optionSelected="selectCategory"
            />
          </div>
          <div>
            <SportButtonSelector @sportSelected="selectSport" />
          </div>
          <div v-if="sportHasFilters()">
            <div class="cursor-pointer" @click="openFilter">
              <SvgContainer name="searchResultFilterIcon" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="search-elements search-elements-container flex flex-wrap items-center justify-center m-auto"
        v-if="selectedCategory === category.BOOKING"
      >
        <div v-for="element in bookingsDataSource" :key="element.tenant.id">
          <BookingsAvailability
            :gallery="element.tenant.gallery"
            :name="element.tenant.name"
            :bestPrice="element.bestPriceLocalized.amountStr"
            :location="element.tenant.address"
            :hours="element.times"
            :distance="element.distance"
            :tenantId="element.tenant.id"
            :cordX="element.tenant.cordX"
            :cordY="element.tenant.cordY"
            :private="element.tenant.private"
            :showTax="element.bestPriceLocalized.withoutTaxes"
            @hourSelected="hourClicked"
            @tenantSelected="tenantClicked"
          />
        </div>
      </div>
      <div
        v-if="noElementsMsg !== ''"
        class="mt-16 mb-8 flex items-center justify-center text-center flex-col"
      >
        <div class="w-32 h-32 flex">
          <SvgContainer name="noResults" />
        </div>
        <div class="mr-2 flex flex-col justify-center items-center">
          <p class="sm:text-xs text-2xl text-center">
            {{ $t('no_results') }}
          </p>
          <p class="sm:text-xs text-center text-gray-500">
            {{ noElementsMsg }}
          </p>
        </div>
      </div>
      <div v-if="selectedCategory === category.MATCH"
        class="search-elements flex flex-wrap items-center justify-center m-auto"
      >
        <MatchAvailability
          :matches="matchesDataSource"
          :showButton="false"
          fromRouteName="search-results"
          @matchSelected="matchSelected"
          @createMatch="createMatch"
        />
      </div>
      <div
        v-if="selectedCategory === category.ACTIVITY"
        class="search-elements flex flex-wrap items-center justify-center m-auto"
      >
        <ActivityAvailability
          :activities="activitiesDataSource"
        />
      </div>
      <div v-if="selectedCategory === category.MATCH">
        <MatchSuggestions
          :filteredDataToSend="filteredDataToSend"
          :showTittle="true"
          :showCreateMatch="showCreateButton"
          @hourSelected="hourSuggestionsClicked"
        />
      </div>
    </div>
    <Transition>
      <PopUpLight v-if="showFilter" @closed="closeFilter()">
        <MultipleFilterSelector
          @sendFilter="handleFilter"
          :filter="filter"
          :sport="sport"
          :category="selectedCategory"
        />
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight
        v-if="showGenderLevel && !isLoading"
        @closed="closeGenderLevel()"
        :customClass="'width-sm'"
        :showClose="false"
      >
        <UpdateUser
          :customSport="sport"
          @closeGenderLevel="closeGenderLevel()"
        />
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showHasGender"
        :showClose="true"
        @closed="initRedPadelLevel"
      >
        <div class="mt-8">
          <UserGenderSelector @selectionChanged="saveGenderChanges" />
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showIframe" 
        @closed="showIframe= false"
        :customClass="'width-lg'"
      >
        <div class="mt-8">
          <iframe class="iframe" title="redPadel login" frameborder="0" :src="iframeSrc"></iframe>
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showRedpadelError" 
        @closed="showRedpadelError= false"
        :customClass="'width-lg'"
      >
        <div class="mt-8">
          {{ $t("oops_technical_problems_try_again_in_a_few_minutes") }}
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight
        v-if="showPopLinkPrivate"
        @closed="showPopLinkPrivate = false"
      >
        <div class="mt-5 flex justify-evenly sm:text-sm">
          <span> {{ $t("the_club_is_private") }} </span>
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight
        v-if="showTimeSelector"
        @closed="showTimeSelector = false"
      >
        <div class="relative w-full input-component justify-center">
          <div class="flex flex-col mt-4 gap-3">
            <div class="flex items-center gap-4">
              <div class="font-bold">
                <TimeSelector 
                  :initialHour="time"
                  @timeSelected="selectDatepick"  
                />
              </div>
              <div class="flex items-center">
                <input
                  type="checkbox"
                  class="cursor-pointer mr-2"
                  v-model="isChecked"
                  @click="handleFlexibleSelected"
                  :class="{ selected: isChecked }"
                  id="check"
                />
                <label
                  class="text-sm cursor-pointer"
                  for="check"
                >
                  {{ flexibleStr }}
                </label>
              </div>
            </div>
            <div>
              <input
                class="search-btn sm:box-border sm:w-auto sm:flex sm:flex-row sm:justify-center sm:items-center sm:p-0 sm:h-12"
                type="button"
                :value="$t('select')"
                @click="updateTime"
              />
            </div>
          </div>
        </div>
      </PopUpLight>
    </Transition>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { defineComponent } from "vue";
import { checkURLAvailabilityFormat, getSearchDataToSend, getDataToBooking, getSportLabel, replaceStateTenantBookingWithHistory} from "@/helpers/dataHelper";
import { beautifyDate, getTimeFromDateString } from "@/helpers/dateHelper";
import SvgContainer from "./SvgContainer.vue";
import SportButtonSelector from "@/components/form/sportButtonSelector.vue";
import PopUpLight from "@/components/popup/popupLight.vue";
import BookingsAvailability from "@/components/search/bookingAvailability.vue";
import MatchAvailability from "@/components/search/matchAvailability.vue";
import ActivityAvailability from "@/components/search/activityAvailability.vue";
import MultipleFilterSelector from "@/components/search/multipleFilterSelector.vue";
import { BookingHelper } from "@/helpers/bookingHelper";
import {Category, SearchType, Sport, BookingViewTabs, Purpose, FLEXIBLE_HOURS} from "@/enum/constants";
import { customGlobalError } from "@/helpers/errorHelper";
import { Format } from "@/helpers/formatHelper";
import { formatDate, setTimeToDate } from "@/helpers/dateHelper";
import { AppsHelper } from "@/helpers/appsHelper";
import UpdateUser from "@/components/match/updateUser.vue";
import CustomerHelper from "@/helpers/customerHelper";
import CategorySelector from "@/components/booking/categorySelector.vue"
import { LevelProvider } from '@/enum/constants';
import MatchHelper from "@/helpers/matchtHelper";
import UserGenderSelector from "@/components/form/userGenderSelector.vue";
import { useRefreshWatcher } from "@/helpers/dataHelper";
import MatchSuggestions from "@/components/match/matchSuggestions.vue"
import DaysSelector from "@/components/buttons/daysSelector.vue"
import TimeSelector from "@/components/form/inputTimeSelector.vue";
import InputWhere from "@/components/form/inputWhereSearch.vue";
import { CustomerApi } from "@/service/CustomerApi";

export default defineComponent({
  components: {
    SvgContainer,
    SportButtonSelector,
    PopUpLight,
    BookingsAvailability,
    MatchAvailability,
    ActivityAvailability,
    MultipleFilterSelector,
    UpdateUser,
    UserGenderSelector,
    CategorySelector,
    MatchSuggestions,
    DaysSelector,
    TimeSelector,
    InputWhere
  },
  data() {
    return {
      category: Category,
      showFilter: false,
      selectedCategory: 0,
      responseSearchItems: null,
      dataToSend: {},
      mainSearchFormPopUpKey: 0,
      noElementsMsg: "",
      isLoading: true,
      filter: {},
      bookingsDataSource: [],
      matchesDataSource: [],
      activitiesDataSource:[],
      createMatchMode: false,
      sport: Sport.PADEL,
      showGenderLevel: false,
      isUserLogged: false,
      level: null,
      createInClub: false,
      levelProvider: LevelProvider.PANDORA,
      hasGender: null,
      showIframe: false,
      showRedpadelError: false,
      showHasGender: false,
      iframeSrc:"",
      defaultLevelProviders: null,
      canCreateMatch: false,
      createMatchQuery: null,
      showPopLinkPrivate: false,
      linkTenantInfo: null,
      tenantIsPrivate: false,
      filteredDataToSend: {},
      time:"",
      showCreateButton: true,
      isChecked: false,
      showTimeSelector: false,
      flexibleStr: "",
      searchType: 0,
      whereSearchQuery: "",
      inputWhereKey:0,
    };
  },
  created() {
    this.flexibleStr = this.$t("im_flexible") + FLEXIBLE_HOURS + ' ' + this.$t("hours")
    this.store = useStore();
    this.searchType = Number(this.$route.query.searchType)
    if(this.searchType == SearchType.FLEXIBLE){
      this.isChecked = true
    }
    this.selectedCategory = Number(this.$route.query.category);
    if (this.$route.query.createMatchMode === "true") {
      this.createMatchMode = true;
    }
    if (this.$route.query.createInClub === "true") {
      this.createInClub = true;
    }
  },
  async mounted() {
    useRefreshWatcher(() => { this.handleRefresh(); });// This function will execute when the 'isRefreshed' state changes. It is passed this way because it is passed by reference.
    this.filteredDataToSend = this.setUpDataFromUrl();
    if (this.$route.query.tenantIds) {
      this.showCreateButton = false
    }
    this.$watch("$route", (to, from) => {
      // Perform actions or checks based on the URL change
      this.sendObjectFromUrl(to.fullPath)
    });
    this.sendObjectFromUrl(window.location.href)
    this.time = getTimeFromDateString(this.$route.query.date)
    this.isLoading = false;
  },
  methods: {
    selectDatepick(time) {
      this.time = time
    },
    updateTime(){
      this.showTimeSelector = false
      const currentQuery = { ...this.$route.query };
      const date = currentQuery.date
      const updatedDate = formatDate(setTimeToDate(new Date(date), this.time))
      this.store.commit("setfullDateTime", updatedDate);
      this.$router.replace({ query: { ...this.$route.query, date: updatedDate, searchType: this.searchType} });
    },
    handleFlexibleSelected() {
      this.isChecked = !this.isChecked;
      this.searchType = this.isChecked ? SearchType.FLEXIBLE : SearchType.EXACT
    },
    handleGetAvailability(date){
      const updatedDate = formatDate(setTimeToDate(new Date(date), this.time))
      this.store.commit("setfullDateTime", updatedDate);
      this.$router.push({ query: { ...this.$route.query, date: updatedDate } });
    },
    async handleTimeSelected(time) {
      const currentQuery = { ...this.$route.query };
      const date = currentQuery.date
      this.time = time
      const updatedDate = formatDate(setTimeToDate(new Date(date), this.time))
      this.store.commit("setfullDateTime", updatedDate);
      this.$router.replace({ query: { ...this.$route.query, date: updatedDate } });
    },
    async linkRedPadelAccount(linkLevelProvider){
      try {
        await CustomerHelper.linkLevelProviderAccount(linkLevelProvider, LevelProvider.REDPADEL);
        this.sendMatch(this.createMatchQuery);
      } catch (error) {
        this.showRedpadelError = true;
      }
    },
    async redPadelListener(event) {
      window.removeEventListener("message", this.redPadelListener);
      const resultData = event.data;
      this.showIframe = false;
      if(resultData.status){
        const linkLevelProvider = {
          accountId: resultData.user_id,
        };
        await this.linkRedPadelAccount(linkLevelProvider);
      }else{
        this.showRedpadelError = true;
      }
    },
    async saveGenderChanges(gender) {
      const user = await CustomerHelper.updateGender(gender);
      if (user) {
        CustomerHelper.updateStorageUser(user);
        this.hasGender = true;
        this.initRedPadelLevel();
      }
      this.showHasGender = false;
    },
    async initGenderLevel() {
      this.hasGender = await CustomerHelper.hasGender();
      if(!this.hasGender && this.levelProvider == LevelProvider.REDPADEL){
        this.showHasGender = true;
        return false;
      }
      this.isLoading = true;
      const hasLevel = await CustomerHelper.hasLevel(this.sport, this.levelProvider);
      this.isLoading = false;
      if((hasLevel)) {
        return true;
      }
      this.levelProvider === LevelProvider.PANDORA ? this.showGenderLevel = true : await this.initRedPadelLevel();
      return false;
    },
    async initRedPadelLevel(){
      this.showHasGender = false;
      if(this.hasGender){
        const response = await CustomerHelper.getProviderRedirectURL(LevelProvider.REDPADEL);
        if(response){
          this.iframeSrc = response.redirectURL;
          this.showIframe = true;
          window.addEventListener("message", this.redPadelListener);
        }
      }
    },
    async selectCategory(option) {
      this.selectedCategory = Number(option);
      const currentQuery = { ...this.$route.query };
      currentQuery.category = this.selectedCategory;
      this.store.commit("setPreferencesAction", option);
      this.$router.replace({ query: currentQuery });
    },
    async selectSport(sport) {
      if (this.sport === sport) {
        return;
      }
      this.sport = sport;
      this.store.commit("setPreferencesSport", sport);
      const currentQuery = { ...this.$route.query };
      currentQuery.sport = this.sport;
      this.$router.replace({ query: currentQuery });
    },
    handleClosePopup() {
      this.closeSearch();
    },
    handleRefresh() {
      const userItem = localStorage.getItem("user");
      if (userItem != null) {
        this.mainSearchFormPopUpKey++;
      }
      this.loadData();
    },
    handleFilter(filter) {
      this.closeFilter(); //TODO: create buton to clear filter
      this.filter = filter;
      //in case of match now don't filter and leave function
      if (this.selectedCategory === Category.MATCH) {
        return;
      }
      //first filter, return only tenants that any filter match
      this.bookingsDataSource = this.responseSearchItems.filter((item) => {
        return item.filters.some((filterItem) => {
          const filterTypeMatch =
            filter.type.length === 0 ||
            filter.type.includes(filterItem.padelType);
          const filterWallMatch =
            filter.subType.length === 0 ||
            filter.subType.includes(filterItem.padelWall);
          const filterSizeMatch =
            filter.size.length === 0 ||
            filter.size.includes(filterItem.padelSize);

          return filterTypeMatch && filterWallMatch && filterSizeMatch;
        });
      });
      //second filter, keep only the filters that match in the filtered tenants, to calculate the lowest best price of mached filters
      this.bookingsDataSource = this.bookingsDataSource.map((item) => {
        const matchingFilters = item.filters.filter(
          (filterItem) =>
            (filter.type.length === 0 ||
              filter.type.includes(filterItem.padelType)) &&
            (filter.subType.length === 0 ||
              filter.subType.includes(filterItem.padelWall)) &&
            (filter.size.length === 0 ||
              filter.size.includes(filterItem.padelSize))
        );
        // Return a new object with the updated filters
        return {
          ...item,
          filters: matchingFilters,
        };
      });
      this.bookingsDataSource = this.mergedFilter(this.bookingsDataSource);
    },
    mergedFilter(filteredTenants) {
      const mergedFilters = filteredTenants.map((filteredTenant) => {
        let times = filteredTenant.filters.reduce((merged, filter) => {
          filter.times.forEach((time) => {
            if (!merged.some(item => item.value === time.value)) {
              merged.push(time);
            }
          });
          return merged;
        }, []);
        times.sort((a, b) => a.value.localeCompare(b.value));

        const smallestPrice = Math.min(
          ...filteredTenant.filters.map((filter) =>
            parseFloat(filter.bestPriceLocalized.amount)
          )
        );
        const matchingFilter = filteredTenant.filters.find(
          (filter) =>
            parseFloat(filter.bestPriceLocalized.amount) === smallestPrice
        );

        return {
          tenant: filteredTenant.tenant,
          filters: filteredTenant.filters,
          bestPriceLocalized:{amountStr: matchingFilter.bestPriceLocalized.amountStr},
          distance: filteredTenant.distance,
          times,
        };
      });
      return mergedFilters;
    },
    handleTenantToBooking(tenant) {
      const currentQuery = { ...this.$route.query };
      const date = currentQuery.date
      const flexible = currentQuery.searchType
      tenant.date = formatDate(new Date(date));
      tenant.flexible = flexible;
      this.store.commit("setTenantInfo", tenant);
      const loc = getDataToBooking(tenant);
      replaceStateTenantBookingWithHistory(tenant); // hacemos el replaceState para que no rompa el historial de navegacion, si hacemos push todo el rato sin cambiar el state al final da undefined y da error al cargar
      this.$router.push(loc);
    },
    handleLocations(locations) {
      if(Array.isArray(locations) && locations.length){
        const location = locations[0]
        const newQuery = { ...this.$route.query };
        let sanitizedQuery = { ...newQuery };// copy of original query
        delete sanitizedQuery.tenantIds; // delete only on copy
        //delete sanitizedQuery.tenantId;
        if(!location.cordX && !location.cordY){
          const userItem = localStorage.getItem("user");
          if (userItem) {
            const user = JSON.parse(userItem);
            if (user.preferences != null) {
              if (user.preferences.tenants != null && user.preferences.tenants.length) {
                const tenantIds = [
                  ...new Set(user.preferences.tenants.map(tenant => tenant.tenantId)) // Set removes duplicated array items
                ];
                sanitizedQuery.tenantIds = tenantIds
              }
            }
          }
        }
        this.$router.replace({
          query: {
            ...sanitizedQuery,
            locName: location.name,
            cordX: location.cordX,
            cordY: location.cordY
          }
        });
      }
    },
    async sendMatch(createMatchQuery){
      if(this.tenantIsPrivate){
        await this.checkPrivateClub();
      }
      if(this.canCreateMatch){
        this.$router.replace(createMatchQuery);
      }
      // start link user
      return this.showPopLinkPrivate = true;
    },
    async hourSuggestionsClicked(data){
      this.tenantIsPrivate = data.private;
      this.levelProvider = MatchHelper.getLevelProviderBySport(data.defaultLevelProviders, this.$route.query.sport);
      this.createMatchQuery = {
          name: "createMatch",
          query: {
            id: data.tenantId,
            name: data.name,
            hour: data.hour,
            date: this.$store.state.fullDateTime,
            sport: this.$route.query.sport,
            category: this.category.MATCH,
            radius: this.$route.query.radius,
            searchType: this.$route.query.searchType,
            levelProvider: this.levelProvider,
            showDateSelector: true
          },
        };
        this.linkTenantInfo = {
          tenant:{ id: data.tenantId } 
        }
        this.canCreateMatch = await this.initGenderLevel();
        if(!this.canCreateMatch){
          return;
        }
        return this.sendMatch(this.createMatchQuery);
    },
    async hourClicked(data) {
      if (this.createMatchMode) {
        this.tenantIsPrivate = data.private;
        var backUrl = this.$route.fullPath;
        if (this.$route.query.createMatchMode === undefined) {
          backUrl += "&createMatchMode=true";
        }
        this.createMatchQuery = {
          name: "createMatch",
          query: {
            id: data.tenantId,
            name: data.name,
            hour: data.hour,
            date: this.$store.state.fullDateTime,
            sport: this.$route.query.sport,
            category: this.category.MATCH,
            radius: this.$route.query.radius,
            searchType: this.$route.query.searchType,
            back: encodeURIComponent(backUrl),
            levelProvider: this.levelProvider
          },
        };
        this.linkTenantInfo = {
          tenant:{ id: data.tenantId } 
        }
        this.canCreateMatch = await this.initGenderLevel();
        if(!this.canCreateMatch){
          return;
        }
        return this.sendMatch(this.createMatchQuery);
      }

      var loc = {
        name: "booking",
        query: {
          id: data.tenantId,
          date: this.$route.query.date,
          sport: this.$route.query.sport,
          category: this.$route.query.category,
          hour: data.hour,
        },
      };
      const tenantInfo = this.responseSearchItems.find(
        (y) => y.tenant.id === data.tenantId
      );
      this.store.commit("setTenantInfo", tenantInfo);
      this.$router.replace(loc);
    },
    async checkPrivateClub(){
      const request = {
        tenantId: this.linkTenantInfo.tenant.id
      }
      const response = await CustomerApi.findLinkedTenantsByCustomer(request);
      if(response?.data.length > 0){
       return this.canCreateMatch = true 
      }
      return this.canCreateMatch = false
    },
    tenantClicked(data) {
      if (this.createMatchMode) {
        return;
      }
      var loc = {
        name: "booking",
        query: {
          id: data.tenantId,
          name: data.name,
          date: this.$route.query.date,
          sport: this.$route.query.sport,
          category: this.$route.query.category,
          tab: BookingViewTabs.HOME,
        },
      };
      const tenantInfo = this.responseSearchItems.find(
        (y) => y.tenant.id === data.tenantId
      );
      this.store.commit("setTenantInfo", tenantInfo);

      this.$router.replace(loc);
    },
    matchSelected(data) {
      let url = "/booking-join/" + data.id;
      if (data.side !== undefined) {
        url += "?s=" + data.side;
      }
      if (data.team !== undefined) {
        url += "&t=" + data.team;
      }
      this.$router.push(url);
    },
    createMatch(match) {
      this.createMatchMode = true;
      this.selectCategory(Category.BOOKING);
    },
    openFilter() {
      this.showFilter = true;
    },
    closeFilter() {
      this.showFilter = false;
    },
    async closeGenderLevel() {
       this.showGenderLevel = false;
       this.canCreateMatch = true;
       this.sendMatch(this.createMatchQuery);
    },
    async sendObjectFromUrl(url) {
      const queryString = url.substring(url.indexOf("?") + 1);
      let queryData = {};
      this.whereSearchQuery = this.$route.query.locName //add location of inputWhere
      this.inputWhereKey++; //refresh inputWhere component

      const params = new URLSearchParams(queryString);

      for (const [key, value] of params.entries()) {
        if (Object.prototype.hasOwnProperty.call(queryData, key)) {
          if (Array.isArray(queryData[key])) {
            queryData[key].push(value !== "" ? value : null);
          } else {
            queryData[key] = [queryData[key], value !== "" ? value : null];
          }
        } else {
          queryData[key] = value !== "" ? value : null;
        }
      }
      this.filteredDataToSend = queryData;
      if (checkURLAvailabilityFormat(queryData)) {
        this.loadData();
      } else {
        this.responseSearchItems = [];
        customGlobalError(this.$t("wrong_url"));
        this.noElementsMsg = this.$t("wrong_url");
      }
    },
    setUpDataFromUrl() {
      const request = {
        date: this.$route.query.date,
        cordX: this.$route.query.cordX,
        cordY: this.$route.query.cordY,
        sport: this.$route.query.sport,
        category: this.$route.query.category,
        radius: this.$route.query.radius,
        searchType: +this.$route.query.searchType,
      };
      
      this.store.commit("setfullDateTime", request.date);
      this.store.commit("setPreferencesPlaces", [
        { cordX: request.cordX, cordY: request.cordY },
      ]);
      this.store.commit("setPreferencesSport", request.sport);
      this.store.commit("setPreferencesAction", request.category);
      this.store.commit("setSearchIsFlexible", request.searchType === SearchType.FLEXIBLE? true : false);
      this.selectedCategory = parseInt(request.category);
      return request
    },
    async loadData() {
      this.bookingsDataSource = [];
      this.matchesDataSource = [];
      this.activitiesDataSource = [];
      this.responseSearchItems = [];
      if (this.selectedCategory === this.category.BOOKING) {
        return await this.loadBookings();
      }
      if (this.selectedCategory === this.category.ACTIVITY) {
        return await this.loadActivities();
      }
      return await this.loadMatches();
    },
    async loadActivities(){
      this.store.commit("setLoading", true);
      this.dataToSend = getSearchDataToSend();
      if (!Format.IsNull(this.$route.query.tenantIds)) {
        this.dataToSend.tenantIds = this.$route.query.tenantIds;
        if (!Array.isArray(this.dataToSend.tenantIds)) {
          this.dataToSend.tenantIds = [this.dataToSend.tenantIds];
        }
      }
      if (!Format.IsNull(this.$route.query.id)) {
        this.dataToSend.tenantIds = [this.$route.query.id];
      }
      this.dataToSend.searchType = SearchType.FULL;
  
      const message = await BookingHelper.messageAvailability(this.dataToSend);
      this.store.commit("setLoading", false);
      if (Format.IsNull(message.activities) || message.activities.length === 0) {
        this.noElementsMsg = this.$t("there_are_no_activities_for_the_selected_date_try_another");
        return;
      }
      this.responseSearchItems = message.activities;
      this.noElementsMsg = "";
      this.activitiesDataSource = this.responseSearchItems;
    },
    async loadBookings() {
      this.store.commit("setLoading", true);
      this.dataToSend = getSearchDataToSend();

      if (!Format.IsNull(this.$route.query.tenantIds)) {
        this.dataToSend.tenantIds = this.$route.query.tenantIds;
        if (!Array.isArray(this.dataToSend.tenantIds)) {
          this.dataToSend.tenantIds = [this.dataToSend.tenantIds];
        }
      }
      if (!Format.IsNull(this.$route.query.id)) {
        this.dataToSend.tenantIds = [this.$route.query.id];
      }
      if(this.createInClub){
        this.dataToSend.searchType = SearchType.FULL;
      }
      // If create match mode, set purpose = 1 (find availability to create match)
      if (this.createMatchMode){
        this.dataToSend.purpose=Purpose.MATCH;
      }
      const message = await BookingHelper.messageAvailability(this.dataToSend);
      this.store.commit("setLoading", false);
      if (Format.IsNull(message.bookings) || message.bookings.length === 0) {
        this.noElementsMsg = this.$t("try_adjusting_your_search");
        return;
      }
      this.noElementsMsg = "";
      this.responseSearchItems = message.bookings;
      this.bookingsDataSource = this.responseSearchItems;

      if(this.bookingsDataSource && this.bookingsDataSource[0].tenant.defaultLevelProviders.length > 0){// if !defaultLevelProviders.length > 0 default level provider always pandora
        this.defaultLevelProviders = this.bookingsDataSource[0].tenant.defaultLevelProviders;
        this.levelProvider = MatchHelper.getLevelProviderBySport(this.defaultLevelProviders, this.sport);
      }
      if (this.isPopup) {
        this.$emit("closePopup");
      }
      this.$emit("searchItems", this.bookingsDataSource);
      this.checkAvailabilityMessage();
      this.fixIphoneHeight();
    },
    async loadMatches() {
      this.store.commit("setLoading", true);
      this.dataToSend = getSearchDataToSend();
      if (!Format.IsNull(this.$route.query.tenantIds)) {
        this.dataToSend.tenantIds = this.$route.query.tenantIds;
        if (!Array.isArray(this.dataToSend.tenantIds)) {
          this.dataToSend.tenantIds = [this.dataToSend.tenantIds];
        }
      }
      if (!Format.IsNull(this.$route.query.id)) {
        this.dataToSend.tenantIds = [this.$route.query.id];
      }
      const message = await BookingHelper.messageAvailability(this.dataToSend);
      this.store.commit("setLoading", false);
      if (Format.IsNull(message.matches) || message.matches.length === 0) {
        this.noElementsMsg = this.$t("try_adjusting_your_search");
        return;
      }
      this.noElementsMsg = "";
      this.responseSearchItems = message.matches.sort((a, b) => new Date(a.date) - new Date(b.date));
      this.checkAvailabilityMessage();
      this.matchesDataSource = this.responseSearchItems
    },
    fixIphoneHeight() {
      if (AppsHelper.isSafariOrIosWebView()) {
        const searchReference = document.querySelector(".search-reference");
        if (searchReference) {
          searchReference.classList.add("pb-100");
        }
      }
    },
    sportHasFilters() {
      return this.sport == Sport.PADEL;
    },
    checkAvailabilityMessage(){
      if (this.responseSearchItems && this.responseSearchItems.length === 0) {
        this.noElementsMsg =
          this.$t("search_no_results_found") +
          " " +
          this.$t(getSportLabel(parseInt(this.dataToSend.sport))) +
          " " +
          this.$t("in") +
          " " +
          this.$route.query.locName +
          " " +
          this.$t("with_date") +
          " " +
          beautifyDate(this.dataToSend.date, true, false);
      }
    },
    closePrivateLink(messageOk){
      this.showPopLinkPrivate = false
      if(messageOk){
        this.canCreateMatch = true;
        return this.sendMatch(this.createMatchQuery);
      }
    }
  },
});
</script>
<style scoped>
:deep(input[type="checkbox"]) {
  -webkit-appearance: checkbox !important;
  -moz-appearance: checkbox !important;
  appearance: checkbox !important;
  background: initial !important;
  border: initial !important;
}
.reference-seach {
  box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(16px);
  height: 44px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid;
  border-radius: 24px;
  border-bottom-color: #264b67;
  border-left-color: #264b67;
  border-right-color: #076ae3;
  border-top-color: #264b67;
}
@media (min-width: 767px) {
  h1 {
    font-family: "Montserrat", sans-serif;
    font-size: 48px;
    font-weight: 600;
    line-height: 67px;
    letter-spacing: 0.04em;
    text-align: center;
    margin-top: 20px;
  }
}
@media (min-width: 767px) {
  .tabs li.image {
    background: rgba(255, 255, 255, 0.02);
    opacity: 0.8;
    box-shadow: inset 0px 0px 15px rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    border-radius: 30px;
    width: 40px;
    height: 40px;
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

label {
  margin: 0px 0px 0px 8px;
}
.tabs li:first-child {
  margin-left: 0px;
}

.tabs li:hover {
  color: #ffffff;
}
.tabs li.image:hover svg path {
  fill: #999999;
}
footer {
  width: 90%;
  margin: 20px auto 0px auto;
  padding-bottom: 0px;
}
footer h3 {
  font-size: 48px;
  font-weight: 600;
}
footer h4 {
  font-size: 24px;
  font-weight: 500;
  line-height: 33.6px;
  display: inline-flex;
  max-width: 140px;
}
footer .open svg {
  position: relative;
  top: -39px;
  left: 145px;
}
.view-courts span {
  position: relative;
  top: 56px;
  left: 42px;
  font: 18px;
  font-weight: 600;
}
.all-tracks {
  width: 184px;
  height: 114px;
  background: #0458e2;
  border-radius: 12px;
}
.all-tracks a {
  position: relative;
  top: 45px;
  left: 40px;
  font: 18px;
  font-weight: 600;
}
input[type="checkbox"] {
  appearance: none;
  background-color: transparent;
  border: 1px solid #f3f3f34d;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  outline: none;
}

input[type="checkbox"].selected {
  box-sizing: border-box;
  position: relative;
  transform: scale(var(--ggs, 1));
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-radius: 100px;
}
input[type="checkbox"].selected::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 5px;
  top: 3px;
  width: 4px;
  height: 7px;
  border-width: 0 1px 1px 0;
  border-style: solid;
  transform-origin: bottom left;
  transform: rotate(45deg);
}
.select-date {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14.5px 142px;
  width: 100%;
  height: 48px;
  background: linear-gradient(
    103.18deg,
    var(--color1) -38.71%,
    var(--color2) 57.77%
  );
  box-shadow: -2px 4px 18px rgba(0, 15, 53, 0.3);
  backdrop-filter: blur(5px);
  border-radius: 32px;
  margin-top: 24px;
}
.search-elements::-webkit-scrollbar {
  -webkit-appearance: none;
}

.search-elements {
  max-width: 1340px;
  gap: 16px;
  margin: 0px auto 20px auto;
}

.search-image {
  background: linear-gradient(
    265.36deg,
    #0356e1 0.37%,
    #23edee 136.83%
  ) !important;
}
.wrapper-icon-home .container-custom-icon {
  border-radius: 50%;
}
.button-disabled {
  opacity: 0.5 !important;
  cursor: default !important;
}
.search-elements-container {
  overflow-y: scroll;
}
</style>